import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import { FORM_CONSULTA_CUPO } from '../../../../../config/forms'
import FormConsultaCupo from '../FormConsultaCupo'

import { consultaCerealVolcadora } from '../../../actions'
import DescargaConsultaEnApp from '../../../components/consultas/DescargaConsultaEnApp'

function ConsultaChofer (props) {
  const { consultaCerealVolcadora } = props

  useEffect(() => {
    consultaCerealVolcadora()
  }, [consultaCerealVolcadora])

  return (
    <>
      <DescargaConsultaEnApp />
      <FormConsultaCupo />
    </>
  )
}

const selector = formValueSelector(FORM_CONSULTA_CUPO)
const mapStateToProps = (state) => ({
  cpa: state.camionesIngreso.cpaConsultaCupo,
  numero: selector(state, 'numero')
})

const mapActionsToProps = {
  consultaCerealVolcadora
}

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(reduxForm({ form: FORM_CONSULTA_CUPO })(ConsultaChofer))
